import styled from 'styled-components';

import { Checkbox as DefaultCheckbox } from 'components/UI/Interactables/Checkbox';

export const CenteredCheckbox = styled(DefaultCheckbox)`
	align-items: center;
	flex-direction: column;
`;
